import React from 'react';

const PrepaymentDetailContext = React.createContext({
  prepaymentDetail: null,
  loadingPrepayment: false,
  refetch: () => {},
});

// Custom hook to use the context
export const usePrepaymentDetailContext = () => {
  const context = React.useContext(PrepaymentDetailContext);

  if (!context) {
    throw new Error('Prepayment Details Context Not Provided');
  }

  return context;
};

export { PrepaymentDetailContext };